import React, { useState, useEffect } from 'react';
import { IconButton } from '../../../../../components/buttons';
import { Input } from '../../../../../components/input';
import { createTicketComment } from '../../../../../store/action/ticket';

const OptionList = (props) => {
    const [ ticketCount, setTicketCount ] = useState({
        all:0,
        active:0,
        processing:0,
        solved:0
    });

    const [ values, setValues ] = useState({
        content:''
    });

    useEffect(() => {
        setTicketCount({
            all:props.tickets.length,
            active:props.tickets.filter(i => i.status === 'active').length,
            processing:props.tickets.filter(i => i.status === 'processing' ).length,
            solved:props.tickets.filter(i => i.status ==='solved' ).length
        })
    },[props.tickets])
    

    return (
        <div className="border-bottom pointer container">
            <div className='row text-sm '>
                <div className='col-11 row'>
                    <div className='col-3 border-right bg-hover-blue'>
                        <div 
                            onClick={() => props.onSelectTab('all')}
                            className={`py-2 px-0 text-center ${props.tab === 'all' ? 'font-weight-bold text-primary' : ''}`}
                        >
                            Semua {ticketCount.all ? `(${ticketCount.all})` : null}
                        </div>
                    </div>
                    <div className='col-3 border-right bg-hover-blue'>
                        <div 
                            onClick={() => props.onSelectTab('active')}
                            className={`py-2 px-0 text-center ${props.tab === 'active' ? 'font-weight-bold text-primary' : ''}`}
                        >
                            Aktif {ticketCount.active ? `(${ticketCount.active})` : null}
                        </div>
                    </div>
                    <div className='col-3 border-right bg-hover-blue'>
                        <div 
                            onClick={() => props.onSelectTab('processing')}
                            className={`py-2 px-0 text-center ${props.tab === 'processing' ? 'font-weight-bold text-primary' : ''}`}
                        >
                            Diproses {ticketCount.processing ? `(${ticketCount.processing})` : null}
                        </div>
                    </div>
                    <div className='col-3 border-right bg-hover-blue'>
                        <div 
                            onClick={() => props.onSelectTab('solved')}
                            className={`py-2 px-0 text-center ${props.tab === 'solved' ? 'font-weight-bold text-primary' : ''}`}
                        >
                            Selesai {ticketCount.solved ? `(${ticketCount.solved})` : null}
                        </div>
                    </div>
                </div>
                
                <div className='col-1 text-center'>
                    <div 
                        onClick={() => props.onClickFilter()}
                        className={`py-2 px-0 text-center`}
                    >
                        <IconButton
                            onClick={() => props.onClickFilter()}  
                            iconClassName="fas fa-filter"
                            style={{backgroundColor:"transparent",borderColor:"transparent",color:`black` }}
                            className="text-center btn-primary-outline py-0"
                        />
                    </div>
                </div>
            </div>
           
        </div>
    )
};

export default OptionList